export default [ 
    {
        key: "allCases",
        status: "",
        label: "You can add notes to change it's status.",
        reject_reason: "",
        uploadEndpoint:"",
        route:"cases",
        actionButtons: [
            {
                endPoint: "updatePOStatus",
                payLoad: {
                    id: "", //record Id To Update
                    newStatus: "Submitted To MD",
                },

                //remove this when not use
                tableSettings:{//settings when we  want a button to open a side bar form
                    route:"caseresponses",
                    uploadEndpoint: "/uploadFile",
                    additionalData:{
                        pkId: "", 
                        createdBy: "" // we set this on the fly
                    }
                },

                getReason: false,//if True, a popup will show to ask user to type the reason
                rejectDialogTitle: "",
                rejectReasonMessage: "",

                buttonLabel: "Add Notes",
                color: 'success',
                icon: "icon-thumbs-up",
                btnSize: "large",

                confirmationTitle: "Submission",
                confirmationMessage: "Are you sure you want to Approved this PO?",
                successMessage: "The Case has been successfully updated.",

                sucessEventName: "changeView",
                successEventValue: "list",
            }, 

            {
                endPoint: "updatePOStatus",
                payLoad: {
                    id: "", //record Id To Update
                    newStatus: "Submitted To MD",
                },

                //remove this when not use
                tableSettings:{//settings when we  want a button to open a side bar form
                    route:"casereasigns",
                    uploadEndpoint: "/uploadFile",
                    filter: {
                        userLink:"",
                        hideFieldInForm:['assignedTo']
                    },
                    additionalData:{
                        pkId: "", 
                        createdBy: "" // we set this on the fly
                    }
                },

                getReason: false,//if True, a popup will show to ask user to type the reason
                rejectDialogTitle: "",
                rejectReasonMessage: "",

                buttonLabel: "Re-Assign",
                color: 'warning',
                icon: "Repeat",
                btnSize: "large",

                confirmationTitle: "Submission",
                confirmationMessage: "Are you sure you want to Approved this PO?",
                successMessage: "The Case has been successfully updated.",

                sucessEventName: "changeView",
                successEventValue: "list",
            }, 
        ]

    },
    // {
    //     key: "yourCases",
    //     status: "1",
    //     label: "You can add notes to change it's status.",
    //     reject_reason: "",
    //     uploadEndpoint:"",
    //     route:"",
    //     actionButtons: [
    //         {
    //             endPoint: "updatePOStatus",
    //             payLoad: {
    //                 id: "", //record Id To Update
    //                 newStatus: "Submitted To MD",
    //             },

    //             //remove this when not use
    //             tableSettings:{//settings when we  want a button to open a side bar form
    //                 route:"caseresponses",
    //                 uploadEndpoint: "/uploadFile",
    //                 additionalData:{
    //                     pkId: "", 
    //                     createdBy: "" // we set this on the fly
    //                 }
    //             },

    //             getReason: false,//if True, a popup will show to ask user to type the reason
    //             rejectDialogTitle: "",
    //             rejectReasonMessage: "",

    //             buttonLabel: "Add Notes",
    //             color: 'success',
    //             icon: "icon-thumbs-up",
    //             btnSize: "large",

    //             confirmationTitle: "Submission",
    //             confirmationMessage: "Are you sure you want to Approved this PO?",
    //             successMessage: "The Case has been successfully updated.",

    //             sucessEventName: "changeView",
    //             successEventValue: "list",
    //         },
         

    //     ]

    // },
   
    //------------------------------------------------------------------------------------------
]